import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import NavList from "./components/NavList";
import NavItem from "./components/NavItem";

/**
 * `handleNavListChildren` injects the `currentMenu` state and `handleItemClick` handler
 */
var handleNavListChildren = function handleNavListChildren(children, currentMenu, handleItemClick) {
  return React.Children.map(children, function (child) {
    var props = child.props,
        type = child.type;
    /**
     * inject `isExpanded` and `handleItemClick` into `NavList` children
     */

    if (type === NavList) {
      return /*#__PURE__*/React.cloneElement(child, {
        isExpanded: currentMenu === props.title,
        handleItemClick: handleItemClick
      });
    }
    /**
     * if it is a fragment and the props have children then handle those children
     */


    if (type === React.Fragment && props.children) {
      return /*#__PURE__*/React.cloneElement(child, {
        children: handleNavListChildren(props.children, currentMenu, handleItemClick)
      });
    }

    return child;
  });
};

var SiteFooter = function SiteFooter(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(SiteFooter.displayName);

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      currentMenu = _useState2[0],
      setCurrentMenu = _useState2[1];

  var handleItemClick = function handleItemClick(menuTitle) {
    if (menuTitle === currentMenu) {
      setCurrentMenu("");
      return;
    }

    setCurrentMenu(menuTitle);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName(),
    "data-rehydratable": getRehydratableName(SiteFooter.displayName)
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, /*#__PURE__*/React.createElement("nav", {
    className: getClassName({
      descendantName: "lists"
    }),
    "aria-label": "footer"
  }, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "listsInner"
    })
  }, handleNavListChildren(children, currentMenu, handleItemClick)))));
};

SiteFooter.defaultProps = {
  isRehydrating: false
};
SiteFooter.displayName = "SiteFooter";
SiteFooter.NavList = NavList;
SiteFooter.NavItem = NavItem;
export default SiteFooter;